import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import i18n from "./plugins/i18n";
import "./filters";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import PrettyCheckbox from "pretty-checkbox-vue";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-icons/iconfont/material-icons.css";
import "./assets/scss/main.scss";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
// @ts-ignore
import VueCountdownTimer from "vuejs-countdown-timer";
import ckEditor from "@ckeditor/ckeditor5-vue2";
import wait from "./plugins/vueWait";
import "./directives/my-src";
import VueMeta from "vue-meta";
import VueMatomo from "vue-matomo";

Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(PrettyCheckbox);
Vue.use(VueCountdownTimer);
Vue.use(VueTelInput);
Vue.use(ckEditor);
store.commit("setBaseURL", process.env.VUE_APP_API_ENDPOINT);
store.commit("setVersion", process.env.VUE_APP_VERSION);
store.commit("setMylobyEnv", process.env.VUE_APP_MYLOBY_ENV);
if (process.env.NODE_ENV === "production") {
  Vue.use(VueMatomo, {
    host: process.env.VUE_APP_MATOMO_ENDPOINT,
    siteId: 1,
    router,
  });
}

/* tslint:disable:no-console */
console.table(process.env);

new Vue({
  i18n,
  router,
  store,
  wait,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
